module.exports = __webpack_public_path__ + "img/58.c5e58ae9.jpg";